import {ChartColors} from "../chart/chart-colors"
import {SkinColors} from "../skin-colors"
import {ColorPalette, ItemColorCoding} from "../../../../fields3/color-coding/color-coding"
import {CorePaleBGPaletteDark} from "../palettes/pale-bg/dark/core"
import {StatusPaleBGPaletteDark} from "../palettes/pale-bg/dark/status"
import {PriorityPaleBGPaletteDark} from "../palettes/pale-bg/dark/priority"
import {SystemPaleBgPaletteDark} from "../palettes/pale-bg/dark/system"

export class DarkSkinColors extends SkinColors {

    get chartColors(): ChartColors {
        return _.assign(super.chartColors, {

            gridLineColor               : "#68768C33",

            tickLabelColor              : '#78787b',

            burnUpTotalColor            : '#7E8B98',
            burnPlanningLabelColor      : '#FFFFFF',
            burnPlanningLabelHaloColor  : 'rgba(0, 0, 0, 0.75)',

            pieStrokeColor              : '#1A222C',
        })
    }

    paleBGColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CorePaleBGPaletteDark[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityPaleBGPaletteDark[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusPaleBGPaletteDark[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemPaleBgPaletteDark[colorCoding.colorNumber]
        }

        return '#FF0000'
    }

    paleColor(colorCoding: ItemColorCoding):string {
        return this.paleBGColor(colorCoding)
    }

    paleBorderColor(colorCoding: ItemColorCoding):string {
        return this.paleBGColor(colorCoding)
    }
}